import * as types from './actionTypes';
import {
  checkSuccess, checkError,
} from './actions';
import { ofType } from 'redux-observable';
import { switchMap, map, debounceTime, catchError } from 'rxjs/operators'
import http from '../../../utils/http';
import { fromPromise } from "rxjs/internal-compatibility";
import { of } from 'rxjs'

export const checkEpic = (actions$, state$) => {
  return actions$.pipe(
    ofType(types.CHECK_REQUEST),
    debounceTime(300),
    switchMap(action => {
      const {data, onSuccess} = action.payload.toJS();
      return fromPromise(http.post('/product/check', data)).pipe(
        map(response => {
          onSuccess && onSuccess();
          return checkSuccess(response.data.data)
        }),
        catchError(err => {
          return of(checkError())
        }))
    }),
  )
};
